export default "__VITE_ASSET__CwX$Yjl$__"